import { MatNativeDateModule } from '@angular/material/core';
import { AppInjectorService } from './core/shared/services/app-injector.service';
import { APP_INITIALIZER, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ConsoleCaptureService } from '@shared/services/debug-info/console-capture.service';
import { NetworkCaptureHttpInterceptor } from '@shared/services/debug-info/network-capture-http-interceptor';
import { RouterModule } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Angulartics2Module } from 'angulartics2';
import { CoreModule } from './core';
import { DirectivesModule } from '@shared/directives';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { translocoLoader } from './transloco.loader';
import type { TranslocoConfig } from '@ngneat/transloco';
import { TranslocoModule, TRANSLOCO_CONFIG } from '@ngneat/transloco';
import { FullscreenOverlayContainer, OverlayContainer } from '@angular/cdk/overlay';
import { ngxMonacoEditorConfig } from '@shared-modules/code-editor-v3/monaco-editor-config';
import { MonacoEditorModule } from '@shared-modules/monaco-editor/editor.module';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule,
    DirectivesModule,
    CoreModule,
    MatSnackBarModule,
    Angulartics2Module.forRoot(),
    MonacoEditorModule.forRoot(ngxMonacoEditorConfig),
    TranslocoModule,
    MatNativeDateModule,
  ],
  providers: [
    MatSnackBar,
    {
      provide: TRANSLOCO_CONFIG,
      useValue: {
        availableLangs: environment.i18n.transloco.availableLangs,
        defaultLang: environment.i18n.transloco.defaultLang,
        fallbackLang: environment.i18n.transloco.fallbackLang,
        prodMode: environment.production,
      } as TranslocoConfig,
    },
    {
      provide: OverlayContainer,
      useClass: FullscreenOverlayContainer,
    },
    translocoLoader,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkCaptureHttpInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (consoleCaptureService: ConsoleCaptureService) => () => consoleCaptureService.install(),
      deps: [ConsoleCaptureService],
      multi: true,
    },
  ],
})
export class AppModule {
  // Global Injector -> Used to manually load dependencies
  public constructor(injector: Injector) {
    AppInjectorService.injector = injector;
  }
}
